var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Popover, PopoverBody, PopoverContent, PopoverTrigger, Portal, useDisclosure, useMultiStyleConfig, } from '@chakra-ui/react';
import { usePopoverWidth, useSelect } from '../hooks';
import { Input } from '../Input';
import { RiArrowDownSLine, RiSearchLine } from './icons';
import { Option, StylesProvider } from './Option';
export const Select = (_a) => {
    var { options, defaultValue, value, placeholder = '请选择', showSearch = false, icon: iconNode, mode, children, prefix, onChange } = _a, props = __rest(_a, ["options", "defaultValue", "value", "placeholder", "showSearch", "icon", "mode", "children", "prefix", "onChange"]);
    const { optionList, selectedOption, isLoading, updateSelect } = useSelect({
        value,
        defaultValue,
        options,
        onChange,
        isMultiple: mode === 'multiple' ? true : false,
    });
    const { onOpen, onClose, isOpen } = useDisclosure();
    const [inputRef, contentWidth] = usePopoverWidth(200);
    const onValueChange = (option) => {
        updateSelect(option);
        if (mode !== 'multiple') {
            setTimeout(() => {
                onClose();
            }, 150);
        }
    };
    const { w, width, size, variant } = props, extraProps = __rest(props, ["w", "width", "size", "variant"]);
    const swidth = width || w || '18rem';
    const styles = useMultiStyleConfig('Select', { size, variant });
    const icon = iconNode || (showSearch ? RiSearchLine : RiArrowDownSLine);
    return (_jsxs(Popover, Object.assign({ placement: "bottom-start", returnFocusOnClose: false, isOpen: isOpen, onOpen: onOpen, onClose: onClose }, { children: [_jsx(PopoverTrigger, { children: _jsx(Input, Object.assign({ ref: inputRef, type: "text", isReadOnly: !showSearch, value: (Array.isArray(selectedOption)
                        ? selectedOption.map((option) => option.label).join(',')
                        : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || '', prefix: prefix, suffix: icon, placeholder: placeholder, cursor: "pointer", size: size, __css: styles.select, width: swidth, isLoading: isLoading }, extraProps)) }), _jsx(Portal, { children: _jsx(PopoverContent, Object.assign({ minWidth: contentWidth, width: contentWidth, rootProps: { zIndex: 'popover' } }, { children: _jsx(PopoverBody, Object.assign({ px: "0", py: "0.5" }, { children: optionList.length === 0 ? (_jsx(_Fragment, {})) : (_jsx(Box, Object.assign({ maxH: "20rem", overflow: "overlay", display: "flex", flexDirection: "column" }, { children: _jsx(StylesProvider, Object.assign({ value: styles }, { children: optionList.map(({ label, value, isDisabled }) => (_jsx(Option, Object.assign({ value: value, isDisabled: isDisabled, isSelected: Array.isArray(selectedOption)
                                        ? selectedOption.some((option) => option.value === value)
                                        : (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === value, onClickOption: onValueChange }, { children: label }), value))) })) }))) })) })) })] })));
};
Select.Option = Option;
export default Select;
